// extracted by mini-css-extract-plugin
export default {"PurchasePage":"PurchasePage_PurchasePage__nVaQr"};